<template>
  <div class="banner pa-4">
    <v-container class="custom-container">
      <v-row dense>
        <v-col cols="12" lg="6">
          <RmsSettingsView></RmsSettingsView>
        </v-col>
        <v-col cols="12" lg="6">
          <ChangeSettingsView></ChangeSettingsView>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ChangeSettingsView from "@/components/Rms/ChangeSettingsView.vue";
import RmsSettingsView from "@/components/Rms/RmsSettingsView.vue";

export default {
  components: { RmsSettingsView, ChangeSettingsView },
  computed: {
    
  },
  methods: {
    
  },
};
</script>
